<script>
    import { client, gql } from "../../GraphQL.svelte";
    import { emptyValuation,
            color as contributorColor,
            removeContributor,
            resendInvitation as resendContributorInvitation
        } from "../../Contributor.svelte";
    import { createEventDispatcher } from 'svelte';
    import ContributorLib from "../../models/participaid/Contributor.js";

    import Card, {Content, PrimaryAction, Media, MediaContent, Actions, ActionButtons, ActionIcons} from '@smui/card';
    import Button, {Label} from '@smui/button';
    import IconButton from '@smui/icon-button';
    import Menu, {SelectionGroup, SelectionGroupIcon} from '@smui/menu';
    import {Anchor} from '@smui/menu-surface';
    import List, {Item, Separator, Text, PrimaryText, SecondaryText, Graphic} from '@smui/list';
    import { cog, pieChart, diamond, plusSquare } from 'svelte-awesome/icons';
    import Icon from 'svelte-awesome';

    import NewEntryDialog from "../dialogs/NewEntryDialog.svelte";
    import ConfigureContributorDialog from "../dialogs/ConfigureContributorDialog.svelte";
    import Overlay from "../Overlay.svelte";
    import ProfilePicture from "../ProfilePicture.svelte";
    import Name from "../Name.svelte";
    import Notification from "../Notification.svelte";
    import Pie from "../Pie.svelte";
    import Line from "../Line.svelte";
    import SettingsButton from "../buttons/SettingsButton.svelte";

    const dispatch = createEventDispatcher();

    export let model;
    export let valuation;
    export let projectId;
    export let projectValuation;
    export let allowEdit;
    export let myUserId;
    export let isOwner;
    export let colors;

    let resendInvitationSuccess = "";
    let resendInvitationErr = "";
    let popup;
    let removeErrMsg = "";
    let editContributorSuccessMsg = "";

    $: color = contributorColor(model, colors);
    $: colorBorderSize = 10;
    $: showContributorConfigDialog = false;
    $: invitationPending = !(model.marketAnnualSalary || model.hourlySalary);
    $: isMe = myUserId == model.user.id;
    $: isMeOrOwner = isMe || isOwner;
    $: valuationLoaded = valuation && projectValuation;

    $: companyValueUpperBound = (valuationLoaded) ? ( (projectValuation.totalContributionWorth < projectValuation.totalOrganisationWorth) ? projectValuation.totalOrganisationWorth : projectValuation.totalContributionWorth ) : 0;
    $: projectValuePercent = (valuationLoaded) ? ((valuation.totalContributionWorth / projectValuation.totalContributionWorth) * 100) : 0;
    $: companyValuePercent = (valuationLoaded) ? ((valuation.totalContributionWorth / companyValueUpperBound) * 100) : 0;

    $: projectValuePieData = (valuationLoaded) ? [
        {value: projectValuation.totalContributionWorth - valuation.totalContributionWorth, color: "#CCC"},
        {value: valuation.totalContributionWorth, color: color}
    ] : undefined;

    $: companyValuePieData = (valuationLoaded) ? [
        {color: "#CCC", value: 100-(companyValuePercent || 0)},
        {value: companyValuePercent || 0, color: color}
    ] : undefined;

    $: if (valuationLoaded) {
        console.log(`Contributor valuation loaded:`);
        console.log(`company value upper bound: ${companyValueUpperBound}`);
        console.log(`project valuation: ${JSON.stringify(projectValuation)}`);
        console.log(`contributor valuation: ${JSON.stringify(valuation)}`);
    }

    $: {
        console.log(`Initializing Contributor color: ${color}`);
        console.log(`Is Project color: ${colors.includes(color)}`);
    }

    function close() {
        showContributorConfigDialog = false;
    }

    function handleAddEntry() {
        // TODO: refactor this into lib
        if (!invitationPending) {
            dispatch("newEntryDialog", model);
        }

        // initialize contributorentry
        else {
            console.log(`[Contributor] did not find market salary information for contributor.`)
            console.log(`[Contributor] The PA should configure the Contributor before adding entries`);
            showContributorConfigDialog = true;
        }
    }

    function handleConfigured(evt) {
        editContributorSuccessMsg = "Successfully supplied salary details for new contributor";
        model = evt.detail;
        close();
    }

    function handleConfiguredUpdated(evt) {
        editContributorSuccessMsg = "Successfully updated contributor salary details";
        model = evt.detail;
        close()
    }

    function remove() {
        removeContributor(projectId, model.id)
            .then(res => {
                dispatch("deletion", model);
            })
            .catch(err => {
                removeErrMsg = "There was an error trying to remove the contributor";
            })
    }

    /*function resendInvitation(contributorId) {
        resendContributorInvitation(projectId, contributorId)
            .then(res => { resendInvitationSuccess = "Resending invitations not yet implemented in API!" })
            .catch(err => {
                console.err(err);
                resendInvitationErr = "There was an error resending invitation email!";
            })
        return false;
    }*/

    function resendInvitation(contributorId) {
        ContributorLib.resendInvitation(projectId, model.id, model.user.emailAddress)
            .then(res => {
                resendInvitationSuccess = "Successfully resent invitation email";
                dispatch("reinvite");
            })
            .catch(err => {
                console.error(err);
                resendInvitationErr = "There was an error resending invitation email!";
            })
    }

    let requestValuation = client.query({
            query: gql`
                query($projectId: Guid!) {
                    projectReportData(projectId: $projectId) {
                        contributorValuations {
                            companySharePercentage,
                            contributorId,
                            contributorName,
                            numberOfStocks,
                            totalContributionWorth
                        }
                    }
                }
            `,
            variables: {
                projectId
            }
        })
        .then(res => {
            console.log(`successfully retrieved contributor valuations`);
            console.log(res);

            res.data.projectReportData.contributorValuations.forEach(val => {
                console.log("found valuation for contributor");

                if (val.contributorId == model.id) {
                    valuation = val;
                }
            });

            if (!valuation) {
                console.log("did not find valuation for contributor! using empty default");
                valuation = emptyValuation(model);
            }
        });

    const settingsButtonStyle = `
        position: absolute;
        top: 10px;
        right: 10px;
        background: 0;
    `;
</script>

<Card class="contributor-card {invitationPending ? 'pending-invitation' : ''}" style="width: 360px; overflow: visible; margin: 25px; margin-top: 50px; border-bottom: {colorBorderSize}px solid {color}; position: relative">
    <span data-contributor-id={model.id} />

    {#if allowEdit}
        <SettingsButton
                onlyIcon
                class="contributor-config-button"
                style={settingsButtonStyle}
                on:click={() => showContributorConfigDialog = true}
        />
    {/if}
    <ProfilePicture user={model.user} style="width: 225px; height: 225px; margin: auto; position: relative; top: -50px; border: {colorBorderSize}px solid {color};" size="5" changeable={isMe}/>
    <Content class="mdc-typography--body2" style="text-align: center">
        <h2 class="contributor-name">
            <Name model={model.user} first={true} last={true}/>
        </h2>
        <h3 class="contributor-title">
            <span>
                {model.title}
                {#if isMe}
                    <span class="identification-label" style="padding: 4px; background: #DDD; color: #666; margin-left: 4px; display: inline-block; font-size: 11px; text-transform: uppercase;">You</span>
                {/if}
            </span>

            {#if invitationPending}
                <span class="invitation-status">
                    <nbsp/>
                    (confirmation pending)
                    {#if isOwner && !resendInvitationSuccess}
                        <div class="resend-invitation">
                            <a href="#" on:click|preventDefault={() => resendInvitation(model.id)}>Resend invite</a>
                        </div>
                    {/if}
                </span>
            {/if}
        </h3>

        <div class="contributor-worth">
            {#await requestValuation}
                ...
            {:then res}
                {#if valuation}
                    +€{(valuation.totalContributionWorth / 100).toFixed(2)}
                {:else}
                    €0,-
                {/if}
            {/await}
        </div>

        <div class="contributor-value">
            {#await requestValuation}
                ...
            {:then res}
                {#if valuation}
                    <div class="valuation-project valuation">
                        <h4>Project value</h4>
                        <Pie values={projectValuePieData} size="75px" style="{projectValuePercent ? '' : 'opacity: 0.4;'}" center percent={projectValuePercent}/>
                        <strong>
                            {#if projectValuePercent}
                                {projectValuePercent.toFixed(2)}%
                            {:else}
                                <span style="color: #DDD;">0%</span>
                            {/if}
                        </strong>
                    </div>

                    <Line orientation="vertical" style="margin: 0 5px;"/>

                    <div class="valuation-company valuation">
                        <h4>Project company</h4>
                        <Pie values={companyValuePieData} size="75px" style="{companyValuePercent ? '' : 'opacity: 0.4;'}" center percent={companyValuePercent}/>
                        <strong>
                            {#if companyValuePercent}
                                {companyValuePercent.toFixed(2)}%
                            {:else}
                                <span style="color: #DDD;">0%</span>
                            {/if}
                        </strong>
                    </div>
                {:else}
                    No valuation found for contributor!
                {/if}
            {/await}
        </div>
    </Content>
    <Actions>
        <ActionButtons>
            {#if !allowEdit}

            {:else if invitationPending && isOwner}
                <Button on:click={handleAddEntry} class="configure-contributor-button">
                    <Label><Icon scale={1} data={cog}/> Configure participant...</Label>
                </Button>
            {:else if isMeOrOwner}
                <Button on:click={handleAddEntry} class="new-entry-button">
                    <Label><Icon scale={1} data={plusSquare}/> Add entry...</Label>
                </Button>
            {/if}
            {#if isMeOrOwner}
<!--                <Button on:click="">-->
<!--                    <Label>Download report</Label>-->
<!--                </Button>-->
            {/if}
        </ActionButtons>
        {#if (isMe && !isOwner) || (isOwner && !isMe)}
            <ActionIcons>
                <span>
                    <IconButton class="material-icons" on:click={() => popup.setOpen(true)} title="More options">more_vert</IconButton>
                    <Menu bind:this={popup}>
                        <List>
                            <Item on:SMUI:action={remove} style="background: #C00; color: white;"><Text>Remove from project</Text></Item>
                        </List>
                    </Menu>
                </span>
            </ActionIcons>
        {/if}
    </Actions>
</Card>

<Overlay show={showContributorConfigDialog} closable={true} background="darken" on:close={close}>
    <ConfigureContributorDialog
            {projectId}
            contributor={model}
            isSelf={myUserId == model.user.id}
            {isOwner}
            on:new={handleConfigured}
            on:update={handleConfiguredUpdated}
    />
</Overlay>

<Notification message={resendInvitationSuccess} type="success"/>
<Notification message={resendInvitationErr} type="error"/>
<Notification message={removeErrMsg} type="error"/>
<Notification message={editContributorSuccessMsg} type="success" />

<style>
    .contributor-config-button {
        position: absolute;
        top: 10px;
        right: 10px;
        background: 0;
    }

    .contributor-name {
        font-size: 30px;
        font-weight: bold;
        margin-top: -40px;
    }

    .contributor-value {
        display: flex;
        flex-direction: row;
        text-align: center;
        padding: 25px 0;
    }

    .contributor-worth {
        font-weight: bold;
        font-size: 25px;
        padding: 15px 0;
        color: #2CD533;
    }

    .contributor-title {
        //font-style: italic;
        text-transform: uppercase;
        font-size: 13px;
        color: #666;
        margin-top: -10px;
    }

    .contributor-value > div {
        flex: 1;
    }

    .contributor-value > div strong {
        font-weight: bold;
        font-size: 20px;
        margin-top: 15px;
        display: block;
    }

    .contributor-value h4 {
        margin-top: 0;
    }

    :global(.contributor-card .new-entry-button) {
        background: #2CD533;
        color: white;
    }

    :global(.contributor-card .mdc-card__actions) {
        background: #fafafa;
    }
</style>